import { Smartlook as SmartlookMobile } from '@awesome-cordova-plugins/smartlook';
import Smartlook from 'smartlook-client';
import { isNativeNotWeb } from '@/utils/platform-check';

// This is called only upon refetching profile, which happens only once till refresh/ login
export const startSmartlook = (email, name, organization, confYear, groupId, tracking) => {
  const delegateType = organization !== 'Heart of God Church' ? 'Delegate' : 'Host';

  if (!isNativeNotWeb()) {
    Smartlook.init(process.env.VUE_APP_SMARTLOOK_API_KEY);
    // To restart the session, use anonymize
    Smartlook.anonymize();

    const trackingObj = {
      name,
      delegateType,
    };

    let identifier = '';
    if (tracking) {
      trackingObj.email = email;
      identifier = `${email}-`;
    }
    identifier += `${Math.ceil(Math.random() * 10000)}`;

    // Identify session
    Smartlook.identify(identifier, trackingObj);
  } else {
    SmartlookMobile.setProjectKey({
      key: process.env.VUE_APP_SMARTLOOK_API_KEY,
    });
    SmartlookMobile.start();
    SmartlookMobile.eventTrackingEnableAll();
    SmartlookMobile.setEventTrackingInteractionUserStatus({
      isEnabled: true,
    });
    SmartlookMobile.setEventTrackingInteractionRageClickStatus({
      isEnabled: true,
    });
    // To restart the session, use anonymize
    // Smartlook.anonymize();

    // Identify session
    SmartlookMobile.setUserIdentifier({
      identifier: `${email}-${Math.ceil(Math.random() * 10000)}`,
    });
    SmartlookMobile.setUserName({ name: name });
    if (tracking) {
      SmartlookMobile.setUserEmail({ email: email });
      SmartlookMobile.setUserProperty({
        propertyName: 'church',
        value: organization,
      });
    }
    SmartlookMobile.setUserProperty({
      propertyName: 'team ID',
      value: groupId,
    });
    SmartlookMobile.setUserProperty({
      propertyName: 'year',
      value: confYear?.split('-')[0],
    });
    SmartlookMobile.setUserProperty({
      propertyName: 'delegateType',
      value: delegateType,
    });
  }
};
